import React from 'react';

const SeatSelector = ({ coaches, onSeatSelect, selectedSeats = [] }) => {
  const [selectedCoach, setSelectedCoach] = React.useState(0);
  const currentCoach = coaches[selectedCoach];

  const isSeatSelected = (seatNumber) => {
    return selectedSeats.some(
      s => s.coachNumber === selectedCoach + 1 && s.seatNumber === seatNumber
    );
  };

  const handleSeatClick = (seatNumber) => {
    const seatObj = {
      coachNumber: selectedCoach + 1,
      seatNumber,
    };

    if (isSeatSelected(seatNumber)) {
      onSeatSelect(seatObj, 'remove');
    } else {
      onSeatSelect(seatObj, 'add');
    }
  };

  if (!currentCoach) return <div>No coaches available</div>;

  return (
    <div className="bg-white p-6 rounded-lg shadow-md">
      <h3 className="text-xl font-bold mb-4">Select Seats</h3>

      {/* Coach Selector */}
      <div className="mb-6">
        <p className="text-sm font-semibold text-gray-700 mb-2">Select Coach:</p>
        <div className="flex gap-2 flex-wrap">
          {coaches.map((coach, idx) => (
            <button
              key={idx}
              onClick={() => setSelectedCoach(idx)}
              className={`px-4 py-2 rounded font-semibold transition ${
                selectedCoach === idx
                  ? 'bg-primary text-white'
                  : 'bg-gray-200 text-gray-800 hover:bg-gray-300'
              }`}
            >
              Coach {coach.coachNumber}
            </button>
          ))}
        </div>
      </div>

      {/* Seat Grid */}
      <div className="mb-6">
        <p className="text-sm font-semibold text-gray-700 mb-4">
          Coach {currentCoach.coachNumber} - {currentCoach.coachType}
        </p>

        {/* Legend */}
        <div className="flex gap-4 mb-4 text-sm">
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-green-500 rounded"></div>
            <span>Available</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-blue-500 rounded"></div>
            <span>Selected</span>
          </div>
          <div className="flex items-center gap-2">
            <div className="w-6 h-6 bg-gray-400 rounded"></div>
            <span>Booked</span>
          </div>
        </div>

        {/* Seat Grid */}
        <div className="grid grid-cols-12 gap-2 p-4 bg-gray-50 rounded-lg">
          {currentCoach.seats.map((seat) => {
            const isSelected = isSeatSelected(seat.seatNumber);
            const isBooked = seat.status === 'booked';

            return (
              <button
                key={seat.seatNumber}
                onClick={() => !isBooked && handleSeatClick(seat.seatNumber)}
                disabled={isBooked}
                className={`w-full h-10 rounded font-semibold text-xs transition ${
                  isBooked
                    ? 'bg-gray-400 cursor-not-allowed'
                    : isSelected
                    ? 'bg-blue-500 text-white'
                    : 'bg-green-500 text-white hover:bg-green-600'
                }`}
              >
                {seat.seatNumber}
              </button>
            );
          })}
        </div>
      </div>

      {/* Selected Seats Summary */}
      {selectedSeats.length > 0 && (
        <div className="mt-4 p-4 bg-blue-50 rounded-lg border border-blue-200">
          <p className="font-semibold text-sm mb-2">Selected Seats ({selectedSeats.length}):</p>
          <div className="flex flex-wrap gap-2">
            {selectedSeats.map((seat, idx) => (
              <span key={idx} className="bg-blue-500 text-white px-3 py-1 rounded text-sm">
                Coach {seat.coachNumber} - Seat {seat.seatNumber}
              </span>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default SeatSelector;
